import { render, staticRenderFns } from "./ReturnProductStockList.vue?vue&type=template&id=181c9a24&scoped=true&"
import script from "./ReturnProductStockList.vue?vue&type=script&lang=js&"
export * from "./ReturnProductStockList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnProductStockList.vue?vue&type=style&index=0&id=181c9a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c9a24",
  null
  
)

export default component.exports